import { render, staticRenderFns } from "./OrderDetailsDialog.vue?vue&type=template&id=51c30e13"
import script from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports